import { render, staticRenderFns } from "./officialSite.vue?vue&type=template&id=274b1fc6"
import script from "./officialSite.vue?vue&type=script&lang=js"
export * from "./officialSite.vue?vue&type=script&lang=js"
import style0 from "./officialSite.vue?vue&type=style&index=0&id=274b1fc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports